import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { InsightsSummaryData } from '../coaching-insight/insight-widget/model/insights-summary-data.model';
import { catchErrorLogRet, mapRetrieve } from '../common/rest.operators';

@Injectable()
export class NextCoachingInsightService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveInsightsSummaryData(
        performerUserId?: number,
        periodTypeId?: number,
        periodDate?: Date,
    ): Observable<InsightsSummaryData> {
        let params = new HttpParams();
        if (performerUserId !== null && performerUserId !== undefined) {
            params = params.set('performerUserId', performerUserId.toString());
        }
        if (periodTypeId !== null && periodTypeId !== undefined) {
            params = params.set('periodTypeId', periodTypeId.toString());
        }
        if (periodDate !== null && periodDate !== undefined) {
            params = params.set('periodDate', periodDate.toJSON());
        }

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/coaching-insight/kpi`,
                { params },
            )
            .pipe(mapRetrieve(), catchErrorLogRet([]));
    }
}
